export const FPS = 30;
export const WIDTH = 1920;
export const HEIGHT = 1080;

export const COLORS = {
  bg: "#050B18",
  bgCard: "#121D38",
  bgCardLight: "#1A2548",
  neonPink: "#FF2D95",
  neonBlue: "#00D4FF",
  neonPurple: "#A855F7",
  neonGreen: "#00FF88",
  neonOrange: "#FF6B35",
  neonYellow: "#FFD60A",
  neonCyan: "#00E5FF",
  neonRed: "#FF3366",
  textPrimary: "#FFFFFF",
  textSecondary: "#B8C5E0",
  textMuted: "#6B7DA0",
};

export const FONTS = {
  heading: "Inter, SF Pro Display, system-ui, sans-serif",
  body: "Inter, SF Pro Text, system-ui, sans-serif",
  mono: "JetBrains Mono, SF Mono, Fira Code, monospace",
};

export const SPRING = {
  snappy: { damping: 200, mass: 0.5 },
  bouncy: { damping: 100, mass: 0.5 },
  gentle: { damping: 150, mass: 0.8 },
  punch: { damping: 80, mass: 0.4 },
};

export const SCENE = {
  query:      { start:    0, duration: 240 }, //  0.0- 8.0s
  scanning:   { start:  240, duration: 150 }, //  8.0-13.0s
  answer:     { start:  390, duration: 600 }, // 13.0-33.0s
  sources:    { start:  990, duration: 270 }, // 33.0-42.0s
  // ── Trust & quality upgrades (shipped July 2026): a build-log intro then
  //    four plain-language before→after cards. ──
  trustIntro: { start: 1260, duration: 105 }, // 42.0-45.5s
  grounded:   { start: 1365, duration: 165 }, // 45.5-51.0s  · completeness critic
  citations:  { start: 1530, duration: 165 }, // 51.0-56.5s  · honest source list
  diagrams:   { start: 1695, duration: 165 }, // 56.5-62.0s  · diagrams that render
  cost:       { start: 1860, duration: 165 }, // 62.0-67.5s  · visible cost
  punchline:  { start: 2025, duration:  90 }, // 67.5-70.5s
};

export const TOTAL_DURATION = 2115; // 70.5s (was 45s; +25.5s of trust/quality upgrades)

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
